export function hasWhiteSpace(s) {
    return s.indexOf(' ') >= 0;
  }

